var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-confirmation',{attrs:{"title":_vm.myResources.title,"confirm-text":_vm.myResources.ctaSave,"confirm-icon-class":"fas fa-save"},on:{"cancel":_vm.onCancel,"confirm":_vm.onSave}},[_c('p',[_vm._v(_vm._s(_vm.myResources.introText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }